export default __webpack_public_path__ + "static/media/Sass.174feccd.png";